export default "__VITE_PUBLIC_ASSET__e3fd4088__"